import React from 'react'
import { Container } from 'react-bootstrap'
import { Route, Switch } from 'react-router'
import AddRecipe from './addRecipe/addRecipe'
import Recipe from './Recipe/recipe'
import Recipes from './Recipes/recipes'
import RecipeCategory from './RecipeCategory/RecipeCategory'

export default function RecipesRouter({ match }) {
    const { path } = match
    return (
        <Container fluid>
            <Switch>
                <Route exact path={`${path}`} component={Recipes} />
                <Route exact path={`${path}/view/:id`} component={Recipe} />
                <Route exact path={`${path}/add`} component={AddRecipe} />
                <Route exact path={`${path}/viewCategory/:id`} component={RecipeCategory} />

            </Switch>
        </Container>
    )
}

